import { PaymentsFeatureFlags, useSelectedLocations } from '@frontend/payments-hooks';
import { useCanDoActionsMulti } from '../use-can-do-actions-multi';
import { useActiveFeatureLocationIds } from './use-active-feature-location-ids';
import { useDataSources } from './use-data-sources';

export const useGeneralSettings = () => {
  const { locationIds } = useSelectedLocations();

  const autoReceiptEnabledLocations = useActiveFeatureLocationIds(PaymentsFeatureFlags.AutoReceiptEnabled);
  const ttpAuthToggleAllowedLocations = useActiveFeatureLocationIds(PaymentsFeatureFlags.TtpAuthenticationToggle);

  const { isPaymentsBillingManager, canModifyWritebacks, canManageSurcharging } = useCanDoActionsMulti(locationIds);
  const {
    drChronoWritebacksLocations,
    openDentalWritebacksLocations,
    openDentalCloudWritebacksLocations,
    eaglesoftWritebacksLocations,
    fuseWritebacksLocations,
    dentrixEnterpriseWritebacksLocations,
    dolphinCloudWritebacksLocations,
    openDentalLocalWritebacksLocations,
    dolphinWritebacksLocations,
    crystalWritebacksLocations,
    athenaOneWritebacksLocations,
    bulkCollectionsEnabledLocations,
    nextechSelectWritebacksLocations,
    nextechPracticeWritebacksLocations,
    dolphinLegacyWritebacksLocations,
  } = useDataSources();

  const showWritebacksSection =
    openDentalWritebacksLocations.length > 0 ||
    openDentalCloudWritebacksLocations.length > 0 ||
    openDentalLocalWritebacksLocations.length > 0 ||
    drChronoWritebacksLocations.length > 0 ||
    eaglesoftWritebacksLocations.length > 0 ||
    fuseWritebacksLocations.length > 0 ||
    dentrixEnterpriseWritebacksLocations.length > 0 ||
    dolphinCloudWritebacksLocations.length > 0 ||
    dolphinWritebacksLocations.length > 0 ||
    crystalWritebacksLocations.length > 0 ||
    athenaOneWritebacksLocations.length > 0 ||
    nextechSelectWritebacksLocations.length > 0 ||
    nextechPracticeWritebacksLocations.length > 0 ||
    dolphinLegacyWritebacksLocations.length > 0;

  const showAuthenticationSection = ttpAuthToggleAllowedLocations.length > 0;

  const showGeneralSettingsSection = showWritebacksSection || showAuthenticationSection;

  return {
    autoReceiptEnabledLocations,
    ttpAuthToggleAllowedLocations,
    openDentalWritebacksLocations,
    openDentalCloudWritebacksLocations,
    openDentalLocalWritebacksLocations,
    eaglesoftWritebacksLocations,
    fuseWritebacksLocations,
    isPaymentsBillingManager,
    canModifyWritebacks,
    drChronoWritebacksLocations,
    showGeneralSettingsSection,
    showWritebacksSection,
    showAuthenticationSection,
    dentrixEnterpriseWritebacksLocations,
    dolphinCloudWritebacksLocations,
    dolphinWritebacksLocations,
    canManageSurcharging,
    bulkCollectionsEnabledLocations,
    crystalWritebacksLocations,
    athenaOneWritebacksLocations,
    nextechSelectWritebacksLocations,
    nextechPracticeWritebacksLocations,
    dolphinLegacyWritebacksLocations,
  };
};
